export const en = {
  // Common
  'app.name': 'Dental Implant Machine',
  'app.shortName': 'DIM',
  'app.footer': '© {year} DIM\'s Dashboard. All rights reserved.',
  
  // Auth
  'auth.login': 'Login',
  'auth.register': 'Register',
  'auth.forgotPassword': 'Forgot Password?',
  'auth.email': 'Email',
  'auth.password': 'Password',
  'auth.confirmPassword': 'Confirm Password',
  'auth.firstName': 'First Name',
  'auth.lastName': 'Last Name',
  'auth.name': 'Name',
  'auth.submit': 'Submit',
  'auth.resetPassword': 'Reset Password',
  'auth.backToLogin': 'Back to Login',
  'auth.welcomeBack': 'Welcome Back',
  'auth.pleaseLogin': 'Please login to your account',
  'auth.rememberMe': 'Remember me',
  'auth.or': 'or',
  'auth.dontHaveAccount': "Don't have an account?",
  'auth.registerNow': 'Register now',
  'auth.required': 'is required',
  'auth.invalid': 'is invalid',
  'auth.passwordsDoNotMatch': 'Passwords do not match',
  'auth.alreadyHaveAccount': 'Already have an account?',
  'auth.createAccount': 'Create Account',
  'auth.fillDetails': 'Please fill in your details',
  'auth.forgotPasswordDesc': 'Enter your email to reset your password',
  'auth.checkEmail': 'Check Your Email',
  'auth.resetInstructions': 'We have sent password reset instructions to your email address.',
  'auth.resetEmailSent': 'Password reset instructions have been sent to your email!',
  'auth.resetEmailFailed': 'Failed to send reset instructions. Please try again.',
  'auth.loginSuccess': 'Login successful',
  'auth.registerSuccess': 'Registration successful',
  'auth.registerError': 'Registration failed. Please try again.',
  'auth.logoutSuccess': 'Logged out successfully',
  'auth.invalidCredentials': 'Email or password is incorrect.',
  'auth.passwordMinLength': 'Password must be at least 8 characters',
  'auth.agreeToTerms': 'You must agree to the terms and conditions',
  'auth.agreeToTermsText': 'I agree to the Terms and Conditions and Privacy Policy',
  
  // Dashboard
  'dashboard.title': 'Dashboard',
  'dashboard.masterReport': 'Master Report',
  'dashboard.profile': 'Profile',
  'dashboard.edit.profile': ' Edit Profile',
  'dashboard.settings': 'Settings',
  'dashboard.help': 'Help',
  'dashboard.logout': 'Logout',
  'dashboard.activeUsers': 'Active Users',
  'dashboard.inactiveUsers': 'Inactive Users',
  'dashboard.totalRevenue': 'Total Revenue',
  'dashboard.activeSessions': 'Active Sessions',
  'dashboard.recentCustomers': 'Recent Customers',
  'dashboard.refresh': 'Refresh',
  'dashboard.welcome': 'Welcome back',
  'dashboard.customers': 'Customers',
  'dashboard.stats': {
    totalCustomers: 'Total Customers',
    activeCustomers: 'Active Customers',
    newCustomers: 'New Customers',
    revenue: 'Revenue',
  },

  // Master Report
  'masterReport.title': 'Master Report',
  'masterReport.table.title': 'Master Report',
  'budgetPacing.title': 'Budget Pacing',
  'budgetPacing.table.title': 'Budget Pacing',
  // Amber Alert
  'amberAlert.title': 'Amber Alerts',
  'amberAlert.table.title': 'Amber Alerts',
  
  // Profile
  'profile.title': 'Profile',
  
  // Documentation
  'docs.title': 'API Documentation',
  
  // Admin
  'admin.title': 'Admin',
  'admin.user': 'User',
  'admin.features': 'Roles',
  'admin.rowLevelSettings': 'Row Level Settings',
  'admin.roles': 'Roles & Permissions',
  'admin.users': 'Users',
  'admin.customers': 'Customers',
  
  // Theme
  'theme.light': 'Light Mode',
  'theme.dark': 'Dark Mode',
  
  // Language
  'language.en': 'English',
  'language.es': 'Spanish',

  // Search
  'search.title': 'Search',
  'search.placeholder': 'Search customers, orders, etc...',

  // Table Columns
  'table.columns.lastLogin': 'SHOW RATE',
  'table.columns.status': 'SET RATE',
  'table.columns.actions': 'Actions',
  'table.columns.name': 'MONTHS',
  'table.columns.email': 'LEADS',
  'table.columns.role': 'Role',
  'table.columns.createdAt': 'Created At',
  'table.columns.updatedAt': 'Updated At',
  'table.columns.description': 'Description',
  'table.columns.type': 'Type',
  'table.columns.phone': 'Phone',
  'table.columns.address': 'Address',
  'table.columns.company': 'Company',
  'table.columns.position': 'Position',
  'table.columns.department': 'Department',
  'table.columns.manager': 'Manager',
  'table.columns.team': 'Team',
  'table.columns.location': 'Location',
  'table.columns.salary': 'Salary',
  'table.columns.startDate': 'Start Date',
  'table.columns.endDate': 'End Date',
  'table.columns.duration': 'Duration',
  'table.columns.progress': 'Progress',
  'table.columns.priority': 'Priority',
  'table.columns.assignedTo': 'Assigned To',
  'table.columns.dueDate': 'Due Date',
  'table.columns.tags': 'Tags',
  'table.columns.category': 'Category',
  'table.columns.amount': 'Amount',
  'table.columns.currency': 'Currency',
  'table.columns.paymentMethod': 'Payment Method',
  'table.columns.transactionId': 'Transaction ID',
  'table.columns.invoiceNumber': 'Invoice Number',
  'table.columns.orderNumber': 'Order Number',
  'table.columns.quantity': 'Quantity',
  'table.columns.price': 'Price',
  'table.columns.total': 'Total',
  'table.columns.discount': 'Discount',
  'table.columns.tax': 'Tax',
  'table.columns.shipping': 'Shipping',
  'table.columns.trackingNumber': 'Tracking Number',
  'table.columns.carrier': 'Carrier',
  'table.columns.estimatedDelivery': 'Estimated Delivery',
  'table.columns.actualDelivery': 'Actual Delivery',
  'table.columns.notes': 'Notes',
  'table.columns.attachments': 'Attachments',
  'table.columns.version': 'Version',
  'table.columns.changes': 'Changes',
  'table.columns.author': 'Author',
  'table.columns.reviewer': 'Reviewer',
  'table.columns.approvedBy': 'Approved By',
  'table.columns.approvedAt': 'Approved At',
  'table.columns.rejectedBy': 'Rejected By',
  'table.columns.rejectedAt': 'Rejected At',
  'table.columns.reason': 'Reason',
  'table.columns.comments': 'Comments',
  'table.columns.rating': 'Rating',
  'table.columns.feedback': 'Feedback',
  'table.columns.satisfaction': 'Satisfaction',
  'table.columns.resolution': 'Resolution',
  'table.columns.severity': 'Severity',
  'table.columns.impact': 'Impact',
  'table.columns.urgency': 'Urgency',
  'table.columns.reportedBy': 'Reported By',
  'table.columns.reportedAt': 'Reported At',
  'table.columns.resolvedBy': 'Resolved By',
  'table.columns.resolvedAt': 'Resolved At',
  'table.columns.closedBy': 'Closed By',
  'table.columns.closedAt': 'Closed At',
  'table.columns.reopenedBy': 'Reopened By',
  'table.columns.reopenedAt': 'Reopened At',
  'table.columns.lastUpdatedBy': 'Last Updated By',
  'table.columns.lastUpdatedAt': 'Last Updated At',

  voice: {
    tooltip: 'Voice Control',
    listening: 'Listening...',
    notSupported: 'Voice control is not supported in your browser',
    error: 'Error with voice recognition',
    navigating: 'Navigating...',
    unknownCommand: 'Unknown command. Try saying "open dashboard" or "go to users"',
  },
} as const 